import * as types from '../const/action.types';

export function forecast(state = {}, action) {
    switch (action.type) {
        case types.LOAD_FORECAST_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function forecasts(state = [], action) {
    switch (action.type) {
        case types.FORECASTS_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function forecastsHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.FORECASTS_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function forecastsIsLoading(state = false, action) {
    switch (action.type) {
        case types.FORECASTS_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/forecast.reducer.js